import { render, staticRenderFns } from "./TextHeader.vue?vue&type=template&id=0e071f39&"
import script from "./TextHeader.vue?vue&type=script&lang=js&"
export * from "./TextHeader.vue?vue&type=script&lang=js&"
import style0 from "./TextHeader.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports